export default __webpack_public_path__ + "static/media/logo-full.24a7ea94.png";